<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsSportif">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour le directeur sportif</h3>
          <!--<button class="btn btn-default btn-xs pull-right"-->
          <!--@click.prevent="getStatsComites(true)">-->
          <!--<i class="fa fa-refresh "></i>-->
          <!--</button>-->
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-6">
              <h4 class="stats-section-title"><i class="fa fa-line-chart"></i> Statistiques particulières</h4>
              <div class="stats-link-list">
                <a href="#" @click.prevent="getStatsExcellSurPlusieursAnnees()" class="stats-link-item">
                  <i class="fa fa-file-excel-o"></i>
                  <span>Statistiques du ranking sur plusieurs années</span>
                </a>
                <a href="#" @click.prevent="getStatsExcellOpens()" class="stats-link-item">
                  <i class="fa fa-file-excel-o"></i>
                  <span>Statistiques des Opens</span>
                </a>
                <a href="#" @click.prevent="getListingDivers('ceintures_noires')" class="stats-link-item">
                  <i class="fa fa-list"></i>
                  <span>Listing des ceintures noires</span>
                </a>
                <a href="#" @click.prevent="getListingDivers('coachs')" class="stats-link-item">
                  <i class="fa fa-users"></i>
                  <span>Listing des coachs</span>
                </a>
                <a href="#" @click.prevent="getListingDivers('brevetes_ADEPS')" class="stats-link-item">
                  <i class="fa fa-graduation-cap"></i>
                  <span>Listing des brevetés ADEPS</span>
                </a>
              </div>
            </div>
            <div class="col-md-6">
              <h4 class="stats-section-title"><i class="fa fa-cogs"></i> Maintenance</h4>
              <div class="stats-link-list">
                <a href="#" @click.prevent="" class="stats-link-item">
                  <i class="fa fa-refresh"></i>
                  <span>Réinitialiser le cache du ranking</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import store from "../../../../vuex/store";

var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');


export default {
  data() {
    return {
      loadingStatsSportif: false
    }

  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getProvinces: 'getProvinces',
      getAuth: 'getAuth'
    }),

  },
  mounted: function () {
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
      setProvinces: 'setProvinces',
    }),
    getListingDivers: function (type_query) {
      let self = this;
      this.loadingStatsSportif = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportListingDivers'),
        JSON.stringify({
          'type_query': type_query
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsSportif = false
        var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
        FileSaver.saveAs(blob, moment().format('DD/MM/YYYY') + " " + type_query + ".xlsx");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier ")
        this.loadingStatsSportif = false
      });
    },
    orderedByYear: function (obj) {
      return _.sortBy(obj, 'annee').reverse()
    },

    getAnnees: function () {
      let retour = [];
      for (let i = 2007; i <= moment().year(); i++) {
        retour.push(i)
      }
      return retour;
    },

    getStatsExcellSurPlusieursAnnees: function () {
      let self = this;
      this.loadingStatsSportif = true

      this.$http.get(self.getRoute('Statistiques.exportStatsRankingPlusieursAnnee')).then((response) => {
      }, (response) => {
      });

      setTimeout(() => {
        self.$noty.success("Le fichier demandé vous sera envoyé par mail dés qu'il sera généré.")
        this.loadingStatsSportif = false
      }, 2000)
    },
    getStatsExcellOpens: function () {
      let self = this;
      this.loadingStatsSportif = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportStatsExcelOpens'),
        JSON.stringify({}),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsSportif = false
        var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
        FileSaver.saveAs(blob, "Statistiques_opens.xlsx");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier ")
        this.loadingStatsSportif = false
      });
    },

    loadProvinces: function () {
      this.$http.get(this.getRoute('getAllProvinces')).then((response) => {
        this.setProvinces(response.body)
      }, (response) => {
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Statistiques/General/General_sportif.vue